import React from 'react';

const Services = () => {
    const services = [
        {
            icon: '🍽️',
            title: 'Dine In Experience',
            description: 'Enjoy our elegant ambiance with premium table service and live music on weekends',
            features: ['Premium seating', 'Live music', 'VIP rooms'],
        },
        {
            icon: '🥡',
            title: 'Quick Takeaway',
            description: 'Order ahead and pick up your favorite dishes packed fresh and ready to go',
            features: ['Pre-order system', 'Express pickup', 'Special packaging'],
        },
        {
            icon: '🚗',
            title: 'Fast Delivery',
            description: 'Hot meals delivered to your doorstep within 45 minutes across the city',
            features: ['Free delivery > 100k', 'Track your order', 'Safe delivery'],
        },
        {
            icon: '🎉',
            title: 'Event Catering',
            description: 'Full-service catering for weddings, corporate events, and private parties',
            features: ['Custom menus', 'Professional staff', 'Full equipment'],
        },
    ];

    return (
        <section id="services" style={styles.section}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <span style={styles.label}>WHAT WE OFFER</span>
                    <h2 style={styles.heading}>Our Premium Services</h2>
                    <p style={styles.subheading}>
                        We provide multiple ways to enjoy our delicious food
                    </p>
                </div>

                <div style={styles.grid}>
                    {services.map((service, index) => (
                        <div key={index} style={styles.card}>
                            <div style={styles.iconWrapper}>
                                <span style={styles.icon}>{service.icon}</span>
                            </div>
                            <h3 style={styles.cardTitle}>{service.title}</h3>
                            <p style={styles.cardDesc}>{service.description}</p>
                            <ul style={styles.featureList}>
                                {service.features.map((feature, idx) => (
                                    <li key={idx} style={styles.featureItem}>
                                        <span style={styles.checkmark}>✓</span>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                            <button style={styles.learnMoreBtn}>
                                Learn More →
                            </button>
                        </div>
                    ))}
                </div>

                <div style={styles.promoSection}>
                    <div style={styles.promoCard}>
                        <div style={styles.promoContent}>
                            <span style={styles.promoLabel}>SPECIAL OFFER</span>
                            <h3 style={styles.promoTitle}>Get 20% Off Your First Order</h3>
                            <p style={styles.promoText}>
                                Download our app and enjoy exclusive discounts on all menu items
                            </p>
                            <div style={styles.promoButtons}>
                                <button style={styles.appButton}>
                                    <span style={styles.appIcon}>📱</span>
                                    Download App
                                </button>
                                <button style={styles.codeButton}>
                                    Use Code: <strong>FIRST20</strong>
                                </button>
                            </div>
                        </div>
                        <div style={styles.promoEmoji}>
                            <span style={styles.bigEmoji}>🎁</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const styles = {
    section: {
        padding: '6rem 2rem',
        backgroundColor: 'var(--white)',
    },
    container: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    header: {
        textAlign: 'center',
        marginBottom: '4rem',
    },
    label: {
        color: 'var(--maroon)',
        fontSize: '0.9rem',
        fontWeight: '700',
        letterSpacing: '2px',
        marginBottom: '1rem',
        display: 'block',
    },
    heading: {
        fontSize: '3rem',
        fontWeight: '800',
        color: 'var(--dark)',
        marginBottom: '1rem',
        letterSpacing: '-1px',
    },
    subheading: {
        fontSize: '1.2rem',
        color: '#666',
        maxWidth: '600px',
        margin: '0 auto',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '2rem',
        marginBottom: '4rem',
    },
    card: {
        backgroundColor: 'var(--cream)',
        padding: '2.5rem',
        borderRadius: '25px',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        border: '2px solid transparent',
    },
    iconWrapper: {
        width: '80px',
        height: '80px',
        backgroundColor: 'var(--white)',
        borderRadius: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '1.5rem',
        boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
    },
    icon: {
        fontSize: '3rem',
    },
    cardTitle: {
        fontSize: '1.6rem',
        fontWeight: '700',
        color: 'var(--dark)',
        marginBottom: '1rem',
    },
    cardDesc: {
        fontSize: '1rem',
        color: '#666',
        lineHeight: '1.7',
        marginBottom: '1.5rem',
    },
    featureList: {
        listStyle: 'none',
        padding: 0,
        marginBottom: '1.5rem',
    },
    featureItem: {
        fontSize: '0.95rem',
        color: '#666',
        marginBottom: '0.7rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    checkmark: {
        color: 'var(--maroon)',
        fontWeight: '800',
        fontSize: '1.1rem',
    },
    learnMoreBtn: {
        backgroundColor: 'transparent',
        color: 'var(--maroon)',
        border: 'none',
        padding: '0.8rem 0',
        fontSize: '1rem',
        fontWeight: '700',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    promoSection: {
        marginTop: '3rem',
    },
    promoCard: {
        backgroundColor: 'var(--maroon)',
        borderRadius: '30px',
        padding: '3rem',
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: '2rem',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
    },
    promoContent: {
        color: 'var(--white)',
    },
    promoLabel: {
        backgroundColor: 'rgba(255,255,255,0.2)',
        padding: '0.5rem 1.2rem',
        borderRadius: '20px',
        fontSize: '0.85rem',
        fontWeight: '700',
        display: 'inline-block',
        marginBottom: '1rem',
    },
    promoTitle: {
        fontSize: '2.5rem',
        fontWeight: '800',
        marginBottom: '1rem',
        lineHeight: '1.2',
    },
    promoText: {
        fontSize: '1.1rem',
        marginBottom: '2rem',
        opacity: 0.9,
    },
    promoButtons: {
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
    },
    appButton: {
        backgroundColor: 'var(--white)',
        color: 'var(--maroon)',
        padding: '1rem 2rem',
        border: 'none',
        borderRadius: '50px',
        cursor: 'pointer',
        fontWeight: '700',
        fontSize: '1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        transition: 'all 0.3s ease',
    },
    appIcon: {
        fontSize: '1.3rem',
    },
    codeButton: {
        backgroundColor: 'transparent',
        color: 'var(--white)',
        padding: '1rem 2rem',
        border: '2px solid var(--white)',
        borderRadius: '50px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '1rem',
        transition: 'all 0.3s ease',
    },
    promoEmoji: {
        textAlign: 'center',
    },
    bigEmoji: {
        fontSize: '10rem',
        opacity: 0.2,
    },
};

export default Services;